var nb_steps
var editor
var editor_text = ""
var readOnlyLines = []
var step

////////////////////////////////////////
//////// Initialize variables //////////
////////////////////////////////////////
$( document ).ready(function() {
  if ($('body').attr('id') == 'getting-started') {
         step = $('[data-currentStep]').data('currentstep')
         nb_steps = 7;
         $(".step").click(function(e) {
            e.preventDefault();
            step = $(this).data("step");
                showStep(step, $(this).attr('href'));
         });

       //Code Mirror editor
        editor = CodeMirror.fromTextArea(document.getElementById('editor'), {
            lineNumbers: true,
            tabsize: 4,
            theme: 'mailjet',
            mode: "text/html",
            htmlMode: true,
            lineWrapping: true,
            autoCloseTags: true
          });

        showStep(step, null, true);
        // "Got it" event
        $(".next_step").click(function(event){
             if (checkValidityEditor() && (step + 1) <= nb_steps) {
                 dataLayer.push({
                    'event' : 'mjml',
                    'eventValue' : 'mjmlTuto-clicked',
                    'step' : $(".step.active").data("stepname"),
                    'skip-btn' : false,
                    'gotIt-btn' : true,
                    'button' : ''
                });
                showStep(step + 1);
                step++;
             }


        });
         $(".skip_step").click(function() {
             if ((step + 1) <= nb_steps) {
                 dataLayer.push({
                    'event' : 'mjml',
                    'eventValue' : 'mjmlTuto-clicked',
                    'step' : $(".step.active").data("stepname"),
                    'skip-btn' : true,
                    'gotIt-btn' : false,
                    'button' : ''
                });
                showStep(step + 1);
                step++;
             }

        });
        //"Back" event
         $(".previous_step").click(function() {
             if (checkValidityEditor() && (step - 1) >= 1) {
                 showStep(step - 1);
                 step--;
             }
        });
        $("#download").click(function () {
            dataLayer.push({
                'event' : 'mjml',
                'eventValue' : 'mjmlTuto-clicked',
                'step' : $(".step.active").data("stepname"),
                'skip-btn' : false,
                'gotIt-btn' : false,
                'button' : 'download'
            });
        });
        $("#doc").click(function () {
            dataLayer.push({
                'event' : 'mjml',
                'eventValue' : 'mjmlTuto-clicked',
                'step' : step,
                'skip-btn' : false,
                'gotIt-btn' : false,
                'button' : 'documentation'
            });
        });
    }
 });

 var editor_text = "";
 var readOnlyLines = [];
 /**
  * This Function initializes editor_text and readOnlyLines
  * and change the editor and the rules of the editor (lines disabled)
  * @param step : step to show to the user
  */
 function editorText(step) {
     switch(step) {
         case 1:
             editor_text = "<mj-section>\n"+
             "        <mj-column>\n" +
             "            //To be filled\n"+
             "        </mj-column>\n" +
             "        <mj-column>\n" +
             "        </mj-column>\n" +
             "</mj-section>";

             readOnlyLines = [ {"from" : 0, "to" : 1}, {"from" : 1, "to" : 2}, {"from" : 3, "to" : 4}, {"from" : 4, "to" : 5},
                               {"from" : 5, "to" : 6}, {"from" : 6, "to" : 7}, {"from" : 7, "to" : 8}, {"from" : 8, "to" : 9},
                             ];
            editor.setOption("readOnly", false);
         break;
         case 2:
             editor_text = "<mj-section>\n"+
             "    <mj-column>\n"+
             "        <mj-text align=\"left\"> Some text for your preheader"+
             " </mj-text>\n"+
             "    </mj-column>\n"+
             "    <mj-column>\n"+
             "        <mj-text align=\"right\"><a href=\"email-permalink\"> Read in the browser </a></mj-text>\n"+
             "    </mj-column>\n"+
             "</mj-section>\n"+
             "<mj-section>\n"+
             "    <mj-column>\n"+
             "        <mj-text align=\"center\"> Lorem ipsum </mj-text>\n"+
             "    </mj-column>\n"+
             "</mj-section>";

             readOnlyLines = [
                          {"from" : 0, "to" : 1}, {"from" : 1, "to" : 2}, {"from" : 2, "to" : 3}, {"from" : 3, "to" : 4},
                          {"from" : 4, "to" : 5},  {"from" : 5, "to" : 6}, {"from" : 6, "to" : 7},{"from" : 7, "to" : 8},
                          {"from" : 9, "to" : 10}, {"from" : 10, "to" : 11}, {"from" : 11, "to" : 12}, {"from" : 12, "to" : 13},
                          {"from" : 13, "to" : 14},
                             ];
            editor.setOption("readOnly", false);
             break;
         case 3:
             editor_text ="<mj-section>\n" +
             "    <mj-column>\n" +
             "        <mj-text align=\"left\"> Some text for your preheader </mj-text>\n" +
             "    </mj-column>\n" +
             "    <mj-column>\n" +
             "        <mj-text align=\"right\"><a href=\"email-permalink\"> Read in the browser </a></mj-text>\n" +
             "    </mj-column>\n" +
             "</mj-section>\n" +
             "<mj-section background-url=\"/assets/img/background-url.jpg\">\n" +
             "    <mj-column>\n" +
             "        <mj-image src=\"\"></mj-image>\n" +
             "        <mj-text align=\"center\"> Lorem ipsum </mj-text>\n" +
             "    </mj-column>\n" +
             "</mj-section>";
             readOnlyLines = [
                  {"from" : 0, "to" : 1}, {"from" : 1, "to" : 2}, {"from" : 2, "to" : 3}, {"from" : 3, "to" : 4},
                  {"from" : 4, "to" : 5}, {"from" : 5, "to" : 6}, {"from" : 6, "to" : 7}, {"from" : 7, "to" : 8},
                  {"from" : 8, "to" : 9}, {"from" : 9, "to" : 10}, {"from" : 11, "to" : 12}, {"from" : 12, "to" : 13},
                  {"from" : 13, "to" : 14},
                     ];
             editor.setOption("readOnly", false);
             break;
         case 4:
             editor_text = "<mj-section>\n" +
             "    <mj-column>\n" +
             "        <mj-text align=\"left\"> Some text for your preheader</mj-text>\n" +
             "    </mj-column>\n" +
             "    <mj-column>\n" +
             "        <mj-text align=\"right\"><a href=\"email-permalink\"> Read in the browser </a></mj-text>\n" +
             "    </mj-column>\n" +
             "</mj-section>\n" +
             "<mj-section background-url=\"/assets/img/background-url.jpg\">\n" +
             "    <mj-column>\n" +
             "        <mj-image src=\"/assets/img/mj-image.jpeg\"></mj-image>\n"+
             "        <mj-text align=\"center\"> Lorem ipsum </mj-text>\n" +
             "        <!-- Add your button here -->\n" +
             "    </mj-column>\n" +
             "</mj-section>";
             readOnlyLines = [
                  {"from" : 0, "to" : 1}, {"from" : 1, "to" : 2}, {"from" : 2, "to" : 3}, {"from" : 3, "to" : 4},
                  {"from" : 4, "to" : 5}, {"from" : 5, "to" : 6}, {"from" : 6, "to" : 7}, {"from" : 7, "to" : 8},
                  {"from" : 8, "to" : 9}, {"from" : 9, "to" : 10}, {"from" : 10, "to" : 11}, {"from" : 11, "to" : 12},
                  {"from" : 13, "to" : 14}, {"from" : 14, "to" : 15},
                     ];
             editor.setOption("readOnly", false);
             break;
         case 5:
            editor_text = "<mj-section>\n" +
             "    <mj-column>\n" +
             "        <mj-text align=\"left\"> Some text for your preheader</mj-text>\n" +
             "    </mj-column>\n" +
             "    <mj-column>\n" +
             "        <mj-text align=\"right\"><a href=\"email-permalink\"> Read in the browser </a></mj-text>\n" +
             "    </mj-column>\n" +
             "</mj-section>\n" +
             "<mj-section background-url=\"/assets/img/background-url.jpg\">\n" +
             "    <mj-column>\n" +
             "        <mj-image src=\"/assets/img/mj-image.jpeg\"></mj-image>\n"+
             "        <mj-text align=\"center\"> Lorem ipsum </mj-text>\n" +
             "        <mj-button> Discover </mj-button>\n" +
             "    </mj-column>\n" +
             "</mj-section>";
            readOnlyLines = [
                  {"from" : 0, "to" : 1}, {"from" : 1, "to" : 2}, {"from" : 2, "to" : 3}, {"from" : 3, "to" : 4},
                  {"from" : 4, "to" : 5}, {"from" : 5, "to" : 6}, {"from" : 6, "to" : 7}, {"from" : 7, "to" : 8},
                  {"from" : 8, "to" : 9}, {"from" : 9, "to" : 10}, {"from" : 10, "to" : 11}, {"from" : 11, "to" : 12},
                  {"from" : 13, "to" : 14}, {"from" : 14, "to" : 15},
                     ];
                     editor.setOption("readOnly", false);
             break;
         case 6:
           editor_text =  "<!doctype html>\n" +
"<html xmlns=\"http://www.w3.org/1999/xhtml\">\n" +
"<head>\n" +
"  <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\">\n" +
"  <title>Getting started with MJML</title>\n" +
"  <style type=\"text/css\">\n" +

"  #outlook a { padding: 0; }\n" +
"  .ReadMsgBody { width: 100%; }\n" +
"  .ExternalClass { width: 100%; }\n" +
"  .ExternalClass * { line-height:100%; }\n" +
" body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }\n" +
" table, td { border-collapse:collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }\n" +
"  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }\n" +
"  p {\n" +
"    display: block;\n" +
"    margin: 13px 0;\n" +
"  }\n" +
"  @media only screen and (min-width:480px) {\n" +
"    .mj-2column, * [aria-labelledby=\"mj-2column\"] { width:50%!important; }\n" +
"    .mj-3column, * [aria-labelledby=\"mj-3column\"] { width:33.3333%!important; }\n" +
"    .mj-4column, * [aria-labelledby=\"mj-4column\"] { width:25%!important; }\n" +
"  }\n" +

"  </style>\n" +
"  <!--[if !mso]><!-->\n" +
"  <style type=\"text/css\">\n" +
"    @import url(https://fonts.googleapis.com/css?family=Ubuntu:400,500,700,300);\n" +
"  </style>\n" +
"  <style type=\"text/css\">\n" +
"    @media only screen and (max-width:480px) {\n" +
"      @-ms-viewport { width:320px; }\n" +
"      @viewport { width:320px; }\n" +
"    }\n" +
"  </style>\n" +
"  <link href=\"https://fonts.googleapis.com/css?family=Ubuntu:400,500,700,300\" rel=\"stylesheet\" type=\"text/css\">\n" +
"  <!--<![endif]-->\n" +
"<style type=\"text/css\">\n" +
"    @media only screen and (min-width:480px) {\n" +
"    }</style></head>\n" +
"<body id=\"YIELD_MJML\" style=\"\"><div class=\"mj-body\"><!--[if mso]>\n" +
"    <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"600\" align=\"center\" style=\"width:600px;\"><tr><td>\n" +
"    <![endif]--><div style=\"margin:0 auto;max-width:600px;\"><table class=\"\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:100%;font-size:0px;\" align=\"center\"><tbody><tr><td style=\"text-align:center;vertical-align:top;font-size:0;padding-top:20px;padding-bottom:20px;\"><!--[if mso]>\n" +
"      <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\"><tr><td style=\"width:300px;\">\n" +
"      <![endif]--><div style=\"vertical-align:top;display:inline-block;font-size:13px;text-align:left;\" class=\"mj-2column\" aria-labelledby=\"mj-2column\" data-column-width=\"NaN\"><table width=\"100%\"><tbody><tr><td style=\"font-size:0;padding-top:10px;padding-bottom:10px;padding-right:25px;padding-left:25px;\" align=\"left\"><div class=\"mj-content\" style=\"cursor:auto;color:#000000;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:22px;\">Some text for your preheader</div></td></tr></tbody></table></div><!--[if mso]>\n" +
"      </td><td style=\"width:300px;\">\n" +
"      <![endif]--><div style=\"vertical-align:top;display:inline-block;font-size:13px;text-align:left;\" class=\"mj-2column\" aria-labelledby=\"mj-2column\" data-column-width=\"NaN\"><table width=\"100%\"><tbody><tr><td style=\"font-size:0;padding-top:10px;padding-bottom:10px;padding-right:25px;padding-left:25px;\" align=\"left\"><div class=\"mj-content\" style=\"cursor:auto;color:#000000;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:22px;\"><a href=\"email-permalink\">Read in the browser</a></div></td></tr></tbody></table></div><!--[if mso]>\n" +
"      </td></tr></table>\n" +
"      <![endif]--></td></tr></tbody></table></div><!--[if mso]>\n" +
"      </td></tr></table>\n" +
"    <![endif]-->\n" +
"    <!--[if mso]>\n" +
"    <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"600\" align=\"center\" style=\"width:600px;\"><tr><td>\n" +
"    <![endif]--><div style=\"margin:0 auto;max-width:600px;background:url(/assets/background-url.jpg) top center /  repeat;\">\n" +
"          <!--[if gte mso 9]>\n" +
"          <v:rect xmlns:v=\"urn:schemas-microsoft-com:vml\" fill=\"true\" stroke=\"false\" style=\"width:600px;\">\n" +
"            <v:fill origin=\"0.5, 0\" position=\"0.5,0\" type=\"tile\" src=\"/assets/background-url.jpg\" />\n" +
"            <v:textbox style=\"mso-fit-shape-to-text:true\" inset=\"0,0,0,0\">\n" +
"          <![endif]--><table class=\"\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:100%;font-size:0px;background:url(/assets/background-url.jpg) top center /  repeat;\" align=\"center\" background=\"/assets/background-url.jpg\"><tbody><tr><td style=\"text-align:center;vertical-align:top;font-size:0;padding-top:20px;padding-bottom:20px;\"><!--[if mso]>\n" +
"      <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\"><tr><td style=\"width:600px;\">\n" +
"      <![endif]--><div style=\"vertical-align:top;display:inline-block;font-size:13px;text-align:left;\" class=\"mj-1column\" aria-labelledby=\"mj-1column\" data-column-width=\"NaN\"><table width=\"100%\"><tbody><tr><td style=\"font-size:0;padding-top:10px;padding-bottom:10px;padding-right:25px;padding-left:25px;\" align=\"center\"><div class=\"mj-content\" style=\"cursor:auto;color:#000000;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:22px;\">Lorem ipsum</div></td></tr><tr><td style=\"font-size:0;padding:15px 30px;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" style=\"border:none;border-radius:3px;\" align=\"center\"><tbody><tr><td style=\"background-color:#F45E43;border-radius:3px;color:#ffffff;cursor:auto;\" align=\"center\" valign=\"middle\" bgcolor=\"#F45E43\"><a class=\"mj-content\" href=\"\" style=\"display:inline-block;text-decoration:none;background-color:#F45E43;border:1px solid #F45E43;border-radius:3px;color:#ffffff;font-size:13px;font-weight:bold;padding:15px 30px;\" target=\"_blank\">Learn more</a></td></tr></tbody></table></td></tr></tbody></table></div><!--[if mso]>\n" +
"      </td></tr></table>\n" +
"      <![endif]--></td></tr></tbody></table>\n" +
"        <!--[if gte mso 9]>\n" +
"          </v:textbox>\n" +
"        </v:rect>\n" +
"        <![endif]-->\n" +
"      </div><!--[if mso]>\n" +
"    </td></tr></table>\n" +
"    <![endif]--></div></body>\n" +
"</html>";
            readOnlyLines = [{"from" : 0, "to" : 1}, {"from" : 1, "to" : 2}, {"from" : 2, "to" : 3}, {"from" : 3, "to" : 4}, {"from" : 4, "to" : 5},
                            {"from" : 5, "to" : 6}, {"from" : 6, "to" : 7}, {"from" : 7, "to" : 8}, {"from" : 8, "to" : 9}, {"from" : 9, "to" : 10},
                            {"from" : 10, "to" : 11}, {"from" : 11, "to" : 12}, {"from" : 12, "to" : 13}, {"from" : 13, "to" : 14}, {"from" : 14, "to" : 15},
                            {"from" : 15, "to" : 16}, {"from" : 16, "to" : 17}, {"from" : 17, "to" : 18}, {"from" : 18, "to" : 19}, {"from" : 19, "to" : 20},
                            {"from" : 20, "to" : 21}, {"from" : 21, "to" : 22}, {"from" : 22, "to" : 23}, {"from" : 23, "to" : 24}, {"from" : 24, "to" : 25},
                            {"from" : 25, "to" : 26}, {"from" : 26, "to" : 27}, {"from" : 27, "to" : 28}, {"from" : 28, "to" : 29}, {"from" : 29, "to" : 30},
                            {"from" : 30, "to" : 31}, {"from" : 31, "to" : 32}, {"from" : 32, "to" : 33}, {"from" : 33, "to" : 34}, {"from" : 34, "to" : 35},
                            {"from" : 35, "to" : 36}, {"from" : 36, "to" : 37}, {"from" : 37, "to" : 38}, {"from" : 38, "to" : 39}, {"from" : 39, "to" : 40},
                            {"from" : 40, "to" : 41}, {"from" : 41, "to" : 42}, {"from" : 42, "to" : 43}, {"from" : 43, "to" : 44}, {"from" : 44, "to" : 45},
                            {"from" : 45, "to" : 46}, {"from" : 46, "to" : 47}, {"from" : 47, "to" : 48}, {"from" : 48, "to" : 49}, {"from" : 49, "to" : 50},
                            {"from" : 50, "to" : 51}, {"from" : 51, "to" : 52}, {"from" : 52, "to" : 53}, {"from" : 53, "to" : 54}, {"from" : 54, "to" : 55},
                            {"from" : 55, "to" : 56}, {"from" : 56, "to" : 57}, {"from" : 57, "to" : 58}, {"from" : 58, "to" : 59}, {"from" : 59, "to" : 60},
                            {"from" : 60, "to" : 61}, {"from" : 61, "to" : 62}, {"from" : 62, "to" : 63}, {"from" : 63, "to" : 64}, {"from" : 64, "to" : 65},
                            {"from" : 65, "to" : 66}, {"from" : 66, "to" : 67}, {"from" : 67, "to" : 68}, {"from" : 68, "to" : 69},];
             break;
         case 7:
             break;
         default:
     }
     $("#editor").prev().hide();
     $("#editor").text(editor_text);
     editor.setValue($("#editor").text());
     $.each(readOnlyLines, function(index, value) {
         editor.markText({line: value.from, ch: 0}, {line: value.to, ch: 0}, {readOnly: true, className: "red-tag"});
         editor.addLineClass(value.from, "text", "getting-started-readonly");
     });
     editor.refresh();

 }

 /**
  * This function checks the validity of the editor
  * TODO
  * @returns {Boolean}
  */
function checkValidityEditor() {
     //TODO check if editor is valid
     return true;
 }

function getStepHistoryPath(number, href) {
     var search = window.location.search || '';
     var hash = '#' + number;

     if (href) {
         var parsedUrl = new URL(href, window.location.href);

         if (parsedUrl.search) {
             search = parsedUrl.search;
         }

         if (parsedUrl.hash) {
             hash = parsedUrl.hash;
         }
     }

     return number + search + hash;
 }

/**
 * Show section number and update the editor
 * @param number : the step section to show
 */
function showStep(number, href, replaceHistory) {
     $.each($(".step"), function () {
         if ($(this).data("step") < number)
             $(this).addClass("done");
         else
             $(this).removeClass("done");
         if ($(this).data("step") == number)
             $(this).addClass("active");
         else
             $(this).removeClass("active");
     });
     $(".section_step.active, .gs-editor").addClass("unreveal");
     setTimeout(function(){
        $(".section_step.active, .gs-editor").removeClass("unreveal active");
        $(".section_step[data-step="+number+"]").addClass("active");
        if (number != 7) {
            $(".gs-editor").addClass("active");
        }
     }, 500);
     setTimeout(function(){
        // Update code of the Editor
        editorText(number);
     }, 501);
     if (number == 1) {
         $("#previous_step").addClass("none");
     } else if ($("#previous_step").hasClass("none")) {
         $("#previous_step").removeClass("none");
     }

     //Put into history
     var historyPath = getStepHistoryPath(number, href);
     if (replaceHistory) {
         history.replaceState({}, "step " + number, historyPath);
     } else {
         history.pushState({}, "step " + number, historyPath);
     }
 }
